import classes from './FormEmployeeSearch.module.css';
import { useTranslation } from 'react-i18next';
import Search from '../../Main/Search/Search';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRoutesContext } from '../../../contexts/RoutesContext';
import { EmployeeSimple } from '../../../contexts/interfaces';

const FormEmployeeSearch = () => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { routes } = useRoutesContext();

    const [employeeSimple, setEmployeeSimple] = useState<EmployeeSimple | null>();

    return (
        <div className={classes.searchContainer}>
            <div className={classes.searchTitle}>
                {t('formEmployeeSearch.title')}
            </div>
            <div className={classes.searchRow}>
                <div className={classes.searchRowHalf}>
                    <Search
                        setEmployeeSimple={setEmployeeSimple}
                    />
                </div>
                <div className={classes.searchRowHalf}>
                    <button
                        className={classes.continueButton}
                        disabled={employeeSimple === null || !employeeSimple?.employeeId}
                        onClick={() => navigate(`/${routes.form}/${employeeSimple?.formId ?
                            employeeSimple.expenseUnit + '/' + employeeSimple?.employeeId + '/' + employeeSimple?.formId // If there's formId
                            : employeeSimple?.expenseUnit + '/' + employeeSimple?.employeeId}` // If there's no formId
                        )}
                    >
                        {t('formEmployeeSearch.continueButton')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FormEmployeeSearch;